<template>
  <div class="row mt-3">
    <div class="col-md-12">
      <h5 class="font-weight-bold">Familiares que fazem uso de:</h5>
      <div v-for="(usuario, index) in item.familiares" :key="index">
        <div
          class="p-0 col-12 mb-3"
          v-if="usuario.saude && usuario.saude.length > 0"
        >
          <table class="table table-bordered">
            <tbody>
              <tr class="col-12">
                <td colspan="2">
                  <router-link :to="'/dashboard/usuario/edit/' + usuario.id">
                    <strong>
                      {{ usuario.nome_completo }}
                    </strong>
                  </router-link>
                  <br />
                  Idade: {{ usuario.idade }} ano(s)<br />
                </td>
              </tr>
              <tr>
                <th>Medicamentos Controlados</th>
                <td>
                  <span v-if="usuario.saude[0].uso_remedio_controlado != null">
                    {{
                      usuario.saude[0].uso_remedio_controlado == 1
                        ? "Sim"
                        : "Não"
                    }}
                  </span>
                  <span v-else>
                    <b-link
                      :to="'/dashboard/usuario/edit/' + usuario.id"
                      title="Informação ausente"
                      v-b-tooltip.hover
                    >
                      <b-icon
                        icon="exclamation-triangle-fill"
                        variant="warning"
                        animation="fade"
                      ></b-icon>
                    </b-link>
                  </span>
                </td>
              </tr>
              <tr>
                <th>Álcool</th>
                <td>
                  <span v-if="usuario.saude[0].uso_abusivo_alcool != null">
                    {{
                      usuario.saude[0].uso_abusivo_alcool == 1 ? "Sim" : "Não"
                    }}
                  </span>
                  <span v-else>
                    <b-link
                      :to="'/dashboard/usuario/edit/' + usuario.id"
                      title="Informação ausente"
                      v-b-tooltip.hover
                    >
                      <b-icon
                        icon="exclamation-triangle-fill"
                        variant="warning"
                        animation="fade"
                      ></b-icon>
                    </b-link>
                  </span>
                </td>
              </tr>
              <tr>
                <th>Drogas</th>
                <td>
                  <span v-if="usuario.saude[0].uso_abusivo_drogas != null">
                    {{
                      usuario.saude[0].uso_abusivo_drogas == 1 ? "Sim" : "Não"
                    }}
                  </span>
                  <span v-else>
                    <b-link
                      :to="'/dashboard/usuario/edit/' + usuario.id"
                      title="Informação ausente"
                      v-b-tooltip.hover
                    >
                      <b-icon
                        icon="exclamation-triangle-fill"
                        variant="warning"
                        animation="fade"
                      ></b-icon>
                    </b-link>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <h4 class="text-secondary" v-if="index == item.familiares.length - 1">
            <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
            Informações ausentes no prontuário do Usuário.
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {};
  },
  methods: {
    submit() {},
  },
};
</script>
